// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"567e1466","255":"bf47be50","264":"cb4c49cf","453":"2d6d3f60","546":"df189525","599":"9846de9d","616":"1c3ca9b3","705":"c3105e7f","959":"42090a48"}[chunkId] + ".chunk.js";
};